import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';

const Index = memo(() => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  const templateScroll = () => {
      return (
        <>
         <div className='scrollTitle'>
          <svg width="12" height="57" viewBox="0 0 12 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.182 52.702C11.182 50.448 9.838 49.076 8.186 49.076C6.674 49.076 5.918 49.958 5.4 51.176L4.798 52.59C4.462 53.43 4.126 54.256 3.244 54.256C2.418 54.256 1.914 53.57 1.914 52.52C1.914 51.61 2.264 50.896 2.838 50.252L1.802 49.398C1.004 50.182 0.499999 51.316 0.499999 52.52C0.499999 54.48 1.718 55.908 3.342 55.908C4.84 55.908 5.624 54.802 6.044 53.808L6.66 52.38C7.08 51.428 7.374 50.728 8.312 50.728C9.18 50.728 9.768 51.428 9.768 52.674C9.768 53.668 9.292 54.676 8.55 55.418L9.67 56.37C10.622 55.432 11.182 54.116 11.182 52.702ZM11.182 42.2664C11.182 40.9364 10.65 39.8864 9.698 39.0604L8.676 39.9284C9.348 40.5444 9.768 41.2724 9.768 42.2104C9.768 44.0304 8.27 45.1784 5.82 45.1784C3.398 45.1784 1.914 43.9464 1.914 42.1684C1.914 41.3284 2.292 40.6844 2.838 40.1524L1.802 39.2704C1.116 39.9004 0.499998 40.9084 0.499999 42.1964C0.499999 44.8004 2.516 46.8444 5.876 46.8444C9.25 46.8444 11.182 44.8564 11.182 42.2664ZM1.998 34.7696L1.998 33.2156C1.998 31.7176 2.432 30.9056 3.678 30.9056C4.924 30.9056 5.54 31.7176 5.54 33.2156L5.54 34.7696L1.998 34.7696ZM11 28.9316L6.632 31.4516C6.226 30.1496 5.274 29.2956 3.678 29.2956C1.452 29.2956 0.695998 30.8916 0.695998 33.0196L0.695998 36.3936L11 36.3936L11 34.7696L6.842 34.7696L6.842 33.1036L11 30.7656L11 28.9316ZM11.182 22.4598C11.182 19.8138 9.124 17.9658 5.806 17.9658C2.488 17.9658 0.499998 19.8138 0.499998 22.4598C0.499998 25.1058 2.488 26.9398 5.806 26.9398C9.124 26.9398 11.182 25.1058 11.182 22.4598ZM9.768 22.4598C9.768 24.1678 8.228 25.2738 5.806 25.2738C3.384 25.2738 1.914 24.1678 1.914 22.4598C1.914 20.7518 3.384 19.6318 5.806 19.6318C8.228 19.6318 9.768 20.7518 9.768 22.4598ZM11 14.9851L11 9.00712L9.628 9.00712L9.628 13.3611L0.695997 13.3611L0.695997 14.9851L11 14.9851ZM11 6.35215L11 0.374154L9.628 0.374154L9.628 4.72815L0.695997 4.72815L0.695997 6.35215L11 6.35215Z" fill="white"/>
          </svg>
        </div>
         <div className='groupArrow'>
            <div className={`arrowLine ${recReSizeReducer <= 750 ? styles.scrollDownM : styles.scrollDown}`}  />
            <div className='arrowNext'>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </>
      )
  }

  const templateScrollNew = () => {
      return (
        <div className="wrapper">
          <div className="wrapper-inner">
            <div className="scroll-down">
                <span className="arrow-down" />
            </div>
          </div>
        </div>
      )
  }

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    return templateScroll();
    // return templateScrollNew();
  };


  return (
      <div className={normal()}>
        {desktopMobile()}
      </div>
  );
});
export default Index;
